/**
 *
 * clip actions
 *
 */

import {
    LOAD_CLIP,
    SET_CLIP_DATA,
    LOAD_CLIP_ERROR,
    RESET_CLIP_DATA
} from './clip-constants';

/**
 * Load the clip data, this action starts the request saga
 *
 * @param  {object} id  The clip unique identifier
 *
 * @return {object}     An action object with a type of LOAD_CLIP
 */
export const loadClip = (id) => ({
    type: LOAD_CLIP,
    id,
});

/**
 * Dispatched when the clip data payload is loaded
 *
 * @param  {object} data    The clip data
 *
 * @return {object}         An action object with a type of SET_CLIP_DATA passing the clip data
 */
export const setClipData = (data) => ({
    type: SET_CLIP_DATA,
    data,
});

/**
 * Dispatched when loading the clip data fails
 *
 * @param  {object} error   The error
 *
 * @return {object}         An action object with a type of LOAD_CLIP_ERROR passing the error
 */
export const clipLoadingError = (error) => ({
    type: LOAD_CLIP_ERROR,
    error,
});

/**
 * Dispatched when unmounting the playback page
 *
 * @return {object}         An action object with a type of RESET_CLIP_DATA
 */
export const resetClipData = () => ({
    type: RESET_CLIP_DATA,
});
